 <p-dialog [header]="Header || defaultHeaderText" [(visible)]="Display" [modal]="true" [resizable]="false" [focusOnShow]="true"
           [draggable]="false" (onHide)="Display = false; DisplayBack.emit(result)">
   <div style="min-width: 400px; min-height: 80px;" [innerHTML]="Message"></div>
   <p-footer>
     <button class="btn-info btn-primary" type="button" (click)="close(true);">{{confirmButton | dictionary}}</button>
     <button class="btn-info btn-primary ml-1" type="button" *ngIf="cancelButton" (click)="close(false)">{{ cancelButton | dictionary }}</button>
   </p-footer>
 </p-dialog>
